import React, { useState } from "react";
import "./blogs.css";
import { FaSun, FaMoon } from "react-icons/fa";
import blog1 from "../assets/motherhood.png";
import blog2 from "../assets/postpar.png";
import blog3 from "../assets/blog3.png";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

function Blogs() {
  const [darkMode, setDarkMode] = useState(false);

  const toggleMode = () => {
    setDarkMode(!darkMode);
  };

  const blogPosts = [
    {
      id: 1,
      date: "Jan 29",
      author: "PreggyZone",
      source: "Skyraan",
      title: "JOURNEY OF MOTHERHOOD",
      excerpt:
        "“Motherhood,” It’s a journey unlike any other, full of unexpected twists, hilarious moments, and a whole lot of love. Whether you’re a first-time mom or welcoming another little one, one thing’s for sure: it’s an adventure that will take you places you never imagined!",
      imageUrl: blog1,
      link: "blog1",
    },
    {
      id: 2,
      date: "Feb 15",
      author: "PreggyZone",
      source: "Skyraan",
      title: " Dealing with Postpartum    ",
      excerpt:
        "Finally, the arrival of your sweet little one—the moment you’ve been waiting for! But then, bam, you’re hit with the postpartum reality check. The adorable baby snuggles are just the beginning; the journey doesn’t stop there. Your body, your mind, and, yes, your emotions are all adjusting to this beautiful new chapter.",
      imageUrl: blog2,
      link: "blog2",
    },
    {
      id: 3,
      date: "Mar 10",
      author: "PreggyZone",
      source: "Skyraan",
      title: "Journey of TTC - How to stay positive",
      excerpt:
        "Trying to conceive can feel like an emotional rollercoaster, one minute you’re feeling hopeful, the next, you’re staring at an empty pregnancy test. For couples, this process can be a mixture of excitement, stress, and at times, overwhelming pressure. When that second line doesn’t appear when you’re hoping for it, it’s natural to feel a bit let down.",
      imageUrl: blog3,
      link: "blog3",
    },
  ];

  return (
    <>
      <div className={`base-blog ${darkMode ? "dark" : "light"}`}>
        <Helmet>
          <title>Ultimate Secrets for Pregnancy: Do's & Don'ts</title>
          <meta
            name="description"
            content="Discover insightful blogs on postpartum depression, fertility tips and much more."
          />
          <meta
            name="keywords"
            content="Pregnancy calculator, Prenatal yoga, postpartum depression, mom to be"
          />
        </Helmet>
        <div className="text">
          <div className="blog-head">
            <h1>Blogs</h1>
            <h4 style={{ marginTop: "25px" , textAlign:"justify" }}>
              Explore our blogs for insights on the entire pregnancy journey,
              from planning to birth and beyond!
            </h4>
            <hr />
          </div>
          <div className="toggle-contents">
            <div
              className={`toggle-container ${darkMode ? "dark" : "light"}`}
              onClick={toggleMode}
            >
              <div className={`toggle-circle ${darkMode ? "dark" : "light"}`}>
                {darkMode ? (
                  <FaMoon className="icon-blog moon" />
                ) : (
                  <FaSun className="icon-blog sun" />
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Dynamically generating cards */}
        {blogPosts.map((post) => (
          <div key={post.id} className="card-container">
            <div className={`card-content ${darkMode ? "dark" : ""}`}>
              <div className="card-content">
                <h5 className="post-meta" style={{ marginBottom: "20px" }}>
                  {post.date} / {post.author} / {post.source}
                </h5>
                <h2 className="post-title">{post.title}</h2>
                <div className="divider"></div>
                <h5 className="post-excerpt">{post.excerpt}</h5>
                <Link to={post.link} className="read-more">
                  READ THE POST
                </Link>
              </div>
            </div>

            <div
              className="card-image"
              style={{ backgroundImage: `url(${post.imageUrl})` }}
            ></div>
          </div>
        ))}
      </div>
    </>
  );
}

export default Blogs;
